import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-family',
  templateUrl: './family.component.html',
  styleUrls: ['./family.component.css']
})
export class FamilyComponent implements OnInit {
  @Input() formStep: FormGroup;

  dropDownOptions1 = [
    { id: 1, value: 'Ensamstående' },
    { id: 2, value: 'Sambo' },
    { id: 3, value: 'Gift' },
  ];

  dropDownOptions2 = [
    { id: 0, value: '0' },
    { id: 1, value: '1' },
    { id: 2, value: '2' },
    { id: 3, value: '3' },
    { id: 4, value: '4' },
    { id: 5, value: '5' },
    { id: 6, value: 'Fler än 5' },
  ];

  dropDownOptions3 = [
    { id: 1, value: 'Inneboende' },
    { id: 2, value: 'Hyreslägenhet' },
    { id: 3, value: 'Bostadsrätt' },
    { id: 4, value: 'Hus' },
    { id: 5, value: 'Saknar boende' },
  ];
  
  constructor() { }

  ngOnInit(): void {
  }

}
